// Must be imported before anything that can trigger a dynamic import().
// WordPress prints window.DARWIN.assetsUrl (see Darwin_Scripts), so lazy
// chunks resolve on any environment without rebuilding.
if (window.DARWIN && window.DARWIN.assetsUrl) {
	__webpack_public_path__ = window.DARWIN.assetsUrl;
}
